import $router from './index'
import $store from './../store'
import { Message as $message } from 'element-ui'

export function getPathWithKey(key) {
  const pathMap = $store.getters.pathMap
  if (key) {
    return pathMap.get(key)
  }
  return key
}

export default {
  //目前只提供 replace 和 push  以及 back
  push: (params) => {
    let route
    if (typeof params === 'string') {
      route = { path: getPathWithKey(params) }
    } else {
      route = { ...params, path: getPathWithKey(params.key) }
    }
    if (!route.path) {
      $message.error('抱歉, 你暂无权限访问，请联系管理员')
      return
    }
    $router.push(route)
  },
  replace: (params) => {
    let route
    if (typeof params === 'string') {
      route = { path: getPathWithKey(params) }
    } else {
      route = { ...params, path: getPathWithKey(params.key) }
    }
    if (!route.path) {
      $message.error('抱歉, 你暂无权限访问，请联系管理员')
      return
    }
    $router.replace(route)
  },
  back: () => {
    $router.back()
  }
}



// WEBPACK FOOTER //
// ./src/router/permissionHistory.js